import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Checkbox,
  TextField,
  Grid,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  Modal,
  Select,
  Autocomplete,
  InputLabel,
  CircularProgress,
  TablePagination,
  ListItemText,
  FormControlLabel,
  Collapse,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextField from "../../../Utils/CustomTextfield";
import {
  deleteProvider,
  getAllFacility,
  getAllProviders,
  registeration,
  updateProvider,
} from "../../../api/action";
import { useDispatch, useSelector } from "react-redux";
import CustomSnackbar from "../../../Utils/CustomSnackbar";
import CustomPagination from "../../../Utils/CustomPagination";
import DeleteModal from "../../../Utils/DeleteModal";
import { phoneRegex } from "../../../Utils/Regex";
import * as XLSX from "xlsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { providerAddSchema, providerEditSchema } from "../../../Utils/validationSchemas";
import FormTextField from "../../../Utils/FormTextField";
import { sanitizeInput, collapseSpaces, normalizePhone } from "../../../Utils/validationSecurity";

const ROWS_PER_PAGE = 10;

const ProviderBody = ({ onEdit, onDelete }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchFacilityCode, setSearchFacilityCode] = useState("");
  const [searchFacilityName, setSearchFacilityName] = useState("");
  const [searchFacilityType, setSearchFacilityType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [facilityList, setFacilityList] = useState([]);
  const [editFacilityList, setEditFacilityList] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [userId, setUserId] = useState("");
  const [data, setData] = useState([]);
  const [allFacilties, setAllFacilities] = useState([]);
  const [loading, setLoading] = useState("");
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [providerId, setProviderID] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [facilityID, setFacilityID] = useState([]);
  const [editFacilityID, setEditFacilityID] = useState([]);
  const [editStatus, setEditStatus] = useState(false);
  const userRole = useSelector((state) => state?.user?.userRole);
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  const [passwordMessage, setPasswordMessage] = useState("");

  const addForm = useForm({
    resolver: yupResolver(providerAddSchema),
    mode: "onChange",
    defaultValues: {
      providercode: "",
      email: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      password: "",
    },
  });

  const editForm = useForm({
    resolver: yupResolver(providerEditSchema),
    mode: "onChange",
    defaultValues: {
      providercode: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      password: "",
    },
  });

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getAllProviders(
        payload,
        (data) => {
          setLoading(false);
          setData(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getAllFacility(
        payload,
        (data) => {
          setLoading(false);
          setAllFacilities(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);


  const handleOpenEditModal = (selectedRow) => {
    setEditModalOpen(true);
    setProviderID(selectedRow.id);
    setEditFacilityList(selectedRow.facility_master);
    setEditFacilityID(
      selectedRow.facility_master?.map((item) => item?.facility_id)
    );
    setEditStatus(selectedRow.is_active);
    setUserId(selectedRow.user_id);
    editForm.reset({
      providercode: selectedRow.providercode || "",
      first_name: selectedRow.First_Name || "",
      last_name: selectedRow.Last_Name || "",
      phone_number: selectedRow.Phone_number || "",
      password: "",
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const selectedCodes = data.map((row) => row.providercode);
      setSelectedRows(selectedCodes);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(event.target.checked);
  };

  const handleCheckboxChange = (providercode) => {
    const isSelected = selectedRows.includes(providercode);
    let updatedSelectedRows = [];
    if (isSelected) {
      updatedSelectedRows = selectedRows.filter(
        (code) => code !== providercode
      );
    } else {
      updatedSelectedRows = [...selectedRows, providercode];
    }
    setSelectedRows(updatedSelectedRows);
    setSelectAll(updatedSelectedRows.length === data.length);
  };

  const handleEditClick = (event, selectedFacility) => {
    setAnchorEl(event.currentTarget);
    setSelectedFacility(selectedFacility);
  };

  const handleEditClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    onDelete(selectedRows);
    setSelectedRows([]);
  };

  const handleAddNew = () => {
    setShowModal(true);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchFacilityCode, searchFacilityName, searchFacilityType]);

  const filteredData = data.filter((row) => {
    const matchesFacilityCode = row.providercode
      .toLowerCase()
      .includes(searchFacilityCode.toLowerCase());
    const matchesFirstName = row.First_Name.toLowerCase().includes(
      searchFacilityName.toLowerCase()
    );
    const matchesLastName = row.Last_Name.toLowerCase().includes(
      searchFacilityType.toLowerCase()
    );
    return matchesFacilityCode && matchesFirstName && matchesLastName;
  });

  const handleClearSearch = () => {
    setSearchFacilityCode("");
    setSearchFacilityName("");
    setSearchFacilityType("");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    addForm.reset();
    setPasswordMessage("");
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setPasswordMessage("");
  };

  const onAddSubmit = (formData) => {
    const payload = {
      email: sanitizeInput(formData.email),
      password: formData.password,
      password2: formData.password,
      first_name: sanitizeInput(formData.first_name),
      last_name: sanitizeInput(formData.last_name),
      providercode: collapseSpaces(sanitizeInput(formData.providercode)),
      phone_number: normalizePhone(sanitizeInput(formData.phone_number)),
      user_role: "Provider",
      facility_master_ids: facilityID,
      is_active: true,
    };

    setLoading(true);
    dispatch(
      registeration(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Provider added successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setShowModal(false);
          setUpdated((prevState) => !prevState);
          addForm.reset();
          setFacilityList([]);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.msg ||
                error.response?.data?.error ||
                error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  useEffect(() => {
    const id = editFacilityList.map((item) =>
      item?.id ? item?.id : item?.facility_id
    );
    setFacilityID(id);
  }, [editFacilityList]);

  const onEditSubmit = (formData) => {
    const payload = {
      first_name: sanitizeInput(formData.first_name),
      last_name: sanitizeInput(formData.last_name),
      provider_id: providerId,
      phone_number: normalizePhone(sanitizeInput(formData.phone_number)),
      facility_master_ids: facilityID,
      is_active: editStatus,
      user_id: userId,
    };
    if (formData.password) {
      payload.password = formData.password;
    }

    setLoading(true);
    dispatch(
      updateProvider(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Provider updated successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setEditModalOpen(false);
          setUpdated((prevState) => !prevState);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.msg ||
                error.response?.data?.error ||
                error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleDeleteProvider = (user_id) => {
    const payload = {
      user_id,
    };

    setLoading(true);
    dispatch(
      deleteProvider(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Provider deleted successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setEditModalOpen(false);
          setUpdated((prevState) => !prevState);
          setOpenDeleteModal(false);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.msg ||
                error.response?.data?.error ||
                error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleDeleteModal = (id) => {
    setOpenDeleteModal(true);
    setProviderID(id);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + ROWS_PER_PAGE
  );
  const endIndex = startIndex + ROWS_PER_PAGE;

  const downloadSelectedRows = () => {
    const exportData = filteredData
      .filter((row) => selectedRows.includes(row.providercode))
      .map((row) => ({
        "Provider Code": row.providercode,
        "Provider First Name": row.First_Name,
        "Provider Last Name": row.Last_Name,
        "Email ID": row.email,
        "Phone Number": row.Phone_number,
        Facilities: row.facility_master
          .map((item) => item.facility_name)
          .join(", "),
      }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    const columnWidths = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
    ];
    ws["!cols"] = columnWidths;
    XLSX.utils.book_append_sheet(wb, ws, "SelectedRows");
    XLSX.writeFile(wb, "selected_rows_data.xlsx");
  };

  const generatePassword = () => {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const special = "@$!%*?&";
    const allChars = uppercase + lowercase + numbers + special;

    let password = "";

    while (!passwordRegex.test(password)) {
      password = "";
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += special[Math.floor(Math.random() * special.length)];

      for (let i = 4; i < 12; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      password = password
        .split("")
        .sort(() => Math.random() - 0.5)
        .join("");
    }

    return password;
  };

  const handleEditGeneratePassword = () => {
    const newPassword = generatePassword();
    editForm.setValue('password', newPassword, { shouldValidate: true });
    setPasswordMessage("✅ New password generated");
  };

  const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    addForm.setValue('password', newPassword, { shouldValidate: true });
    setPasswordMessage("✅ New password generated");
  };

  return (
    <Box sx={{ px: 5, py: 2 }}>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        loading={loading}
        setLoading={setLoading}
        handleDeletefunction={handleDeleteProvider}
        id={providerId}
      />
      <Typography
        variant="h6"
        sx={{ color: "rgba(29, 57, 105, 1)", fontWeight: "bold" }}
      >
        Search Provider Master
      </Typography>
      <Grid container spacing={5} sx={{ py: 2 }}>
        <Grid item md={4} xs={6}>
          <InputLabel>Provider Code</InputLabel>
          <CustomTextField
            value={searchFacilityCode}
            setValue={setSearchFacilityCode}
          />
        </Grid>
        <Grid item md={4} xs={6}>
          <InputLabel>Provider First Name</InputLabel>
          <CustomTextField
            value={searchFacilityName}
            setValue={setSearchFacilityName}
          />
        </Grid>
        <Grid item md={4} xs={6}>
          <InputLabel>Provider Last Name</InputLabel>
          <CustomTextField
            value={searchFacilityType}
            setValue={setSearchFacilityType}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "end", mb: 3 }}>
        <Button
          className="buttonPadding"
          variant="contained"
          onClick={handleClearSearch}
          sx={{
            background: "rgba(29, 57, 105, 1)",
            boxShadow: "none !important",
            ml: 1,
            color: "#fff",
          }}
        >
          Clear
        </Button>
        <Button
          disabled={userRole !== "Admin"}
          className="buttonPadding"
          variant="contained"
          onClick={handleAddNew}
          sx={{
            background:
              userRole !== "Admin" ? "#d3d3d3" : "rgba(29, 57, 105, 1)",
            boxShadow: "none !important",
            mx: 1,
            color: "#fff",
          }}
        >
          Add New
        </Button>

        <Button
          sx={{
            float: "right",
            boxShadow: "none !important",
            color: "#fff",
            background:
              selectedRows.length === 0 ? "#d2d2d2" : "rgba(29, 57, 105, 1)",
          }}
          variant="contained"
          onClick={downloadSelectedRows}
          disabled={selectedRows.length === 0}
        >
          Download Excel
        </Button>
      </Box>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <CircularProgress sx={{ color: "rgba(29, 57, 105, 1) !important" }} />
        </Box>
      ) : filteredData.length === 0 ? (
        <Typography
          variant="body2"
          sx={{ textAlign: "center", color: "#555", mt: 15 }}
        >
          No Data Available
        </Typography>
      ) : (
        <>
          <TableContainer component={Paper} className="scrollBar">
            <Table>
              <TableHead
                sx={{
                  background: "rgba(29, 57, 105, 1)",
                  color: "#fff",
                }}
              >
                <TableRow>
                  <TableCell
                    sx={{
                      py: 0,
                      color: "#fff",
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      style={{ color: "#fff" }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Provider Code
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Provider First Name
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Provider Last Name
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Email ID
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Phone Number
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Facilities
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                  >
                    Status
                  </TableCell>
                  <TableCell sx={{ color: "#fff", py: 0 }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.slice(startIndex, endIndex).map((row) => (
                  <TableRow key={row.facilityCode}>
                    <TableCell sx={{ py: 0.3 }}>
                      <Checkbox
                        checked={selectedRows.includes(row.providercode)}
                        onChange={() => handleCheckboxChange(row.providercode)}
                        style={{ color: "rgba(29, 57, 105, 1)" }}
                        size="small"
                      />
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row.providercode}
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row.First_Name}
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row.Last_Name}
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row.email}
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row.Phone_number}
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row.facility_master.map((item, index) => (
                        <Box key={index}>{item?.facility_name}</Box>
                      ))}
                    </TableCell>
                    <TableCell
                      className="fs12"
                      sx={{ py: 0.3, whiteSpace: "nowrap" }}
                    >
                      {row?.is_active === true ? "Active" : "Inactive"}
                    </TableCell>
                    <TableCell sx={{ py: 0.3, whiteSpace: "nowrap" }}>
                      <IconButton
                        disabled={userRole !== "Admin"}
                        color="primary"
                        onClick={() => handleOpenEditModal(row)}
                      >
                        <EditIcon
                          sx={{
                            color:
                              userRole !== "Admin"
                                ? "#d3d3d3"
                                : "rgba(29, 57, 105, 1)",
                            fontSize: "16px",
                          }}
                        />
                      </IconButton>
                      <IconButton
                        disabled={userRole !== "Admin"}
                        color="secondary"
                        onClick={() => handleDeleteModal(row.user_id)}
                      >
                        <DeleteIcon
                          sx={{
                            color:
                              userRole !== "Admin"
                                ? "#d3d3d3"
                                : "rgba(29, 57, 105, 1)",
                            fontSize: "16px",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <CustomPagination
            count={Math.ceil(filteredData.length / ROWS_PER_PAGE)}
            page={currentPage}
            onChange={handleChangePage}
          />
        </>
      )}

      {/* Add Modal  */}

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "60vw",
            px: 5,
            py: 5,
            borderRadius: "6px",
            height: "80vh",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            <Typography
              className="fs16"
              sx={{ fontWeight: 600, color: "rgba(29, 57, 105, 1)" }}
            >
              Add Provider Master
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon
                sx={{
                  color: "#fff",
                  background: "rgba(29, 57, 105, 1)",
                  borderRadius: "25px",
                  height: 20,
                  width: 20,
                  p: 0.5,
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ my: 2 }} component="form" onSubmit={addForm.handleSubmit(onAddSubmit)}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <InputLabel>Provider Code</InputLabel>
                <FormTextField
                  name="providercode"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={20}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Email</InputLabel>
                <FormTextField
                  name="email"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={254}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Provider First Name</InputLabel>
                <FormTextField
                  name="first_name"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={50}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Provider Last Name</InputLabel>
                <FormTextField
                  name="last_name"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={50}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Phone Number</InputLabel>
                <FormTextField
                  name="phone_number"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={20}
                />
              </Grid>
              <Grid item md={12}>
                <InputLabel>Password</InputLabel>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <FormTextField
                      name="password"
                      register={addForm.register}
                      errors={addForm.formState.errors}
                      watch={addForm.watch}
                      maxLength={128}
                      type="password"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={handleGeneratePassword}
                      type="button"
                      sx={{
                        whiteSpace: "nowrap",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <Typography variant="caption">
                        Generate Password
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
                <Collapse in={Boolean(passwordMessage)}>
                  <Typography variant="caption" sx={{ color: "green" }}>
                    {passwordMessage}
                  </Typography>
                </Collapse>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Password must be at least 8 characters long, and include one
                  uppercase letter, one lowercase letter, one number, and one
                  special character (@$!%*?&).
                </Typography>
              </Grid>
              <Grid item md={12}>
                <InputLabel>Facilty</InputLabel>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  fullWidth
                  value={facilityList}
                  onChange={(event, newValue) => {
                    setFacilityList(newValue);
                    setFacilityID(newValue.map((option) => option.id));
                  }}
                  sx={{ height: "auto !important" }}
                  options={allFacilties}
                  getOptionLabel={(option) => `${option.facility_name}`}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <FormControlLabel
                        control={<Checkbox checked={selected} />}
                        label={<ListItemText primary={option.facility_name} />}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& input": {
                          height: "auto !important",
                          padding: "5px 10px",
                        },
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              type="submit"
              sx={{
                boxShadow: "none !important",
                display: "block",
                mt: 3,
                ml: "auto",
              }}
            >
              {loading ? (
                <CircularProgress size={18} sx={{ color: "#fff" }} />
              ) : (
                "Add"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={editModalOpen}
        onClose={handleCloseEditModal}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "60vw",
            px: 5,
            py: 5,
            borderRadius: "6px",
            height: "80vh",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            <Typography
              className="fs16"
              sx={{ fontWeight: 600, color: "rgba(29, 57, 105, 1)" }}
            >
              Edit Provider Master
            </Typography>
            <IconButton onClick={handleCloseEditModal}>
              <CloseIcon
                sx={{
                  color: "#fff",
                  background: "rgba(29, 57, 105, 1)",
                  borderRadius: "25px",
                  height: 20,
                  width: 20,
                  p: 0.5,
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ my: 2 }} component="form" onSubmit={editForm.handleSubmit(onEditSubmit)}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <InputLabel>Provider Code</InputLabel>
                <FormTextField
                  name="providercode"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={20}
                  disabled
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Provider First Name</InputLabel>
                <FormTextField
                  name="first_name"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={50}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Provider Last Name</InputLabel>
                <FormTextField
                  name="last_name"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={50}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Phone Number</InputLabel>
                <FormTextField
                  name="phone_number"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={20}
                />
              </Grid>

              <Grid item md={6} xs={6}>
                <InputLabel>Status</InputLabel>
                <Select
                  fullWidth
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                  sx={{ height: "32px", padding: "5px 5px", fontSize: "12px" }}
                >
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </Grid>

              <Grid item md={12}>
                <InputLabel>Password</InputLabel>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <FormTextField
                      name="password"
                      register={editForm.register}
                      errors={editForm.formState.errors}
                      watch={editForm.watch}
                      maxLength={128}
                      type="password"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Button
                      onClick={handleEditGeneratePassword}
                      type="button"
                    >
                      <Typography variant="caption">
                        Generate Password
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>

                <Collapse in={Boolean(passwordMessage)}>
                  <Typography variant="caption" sx={{ color: "green" }}>
                    {passwordMessage}
                  </Typography>
                </Collapse>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Password must be at least 8 characters long, and include one
                  uppercase letter, one lowercase letter, one number, and one
                  special character (@$!%*?&).
                </Typography>
              </Grid>

              <Grid item md={12}>
                <InputLabel>Facilty</InputLabel>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  fullWidth
                  value={editFacilityList}
                  onChange={(event, newValue) => {
                    setEditFacilityList(newValue);
                  }}
                  options={allFacilties}
                  getOptionLabel={(option) => `${option.facility_name}`}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <FormControlLabel
                        control={<Checkbox checked={selected} />}
                        label={<ListItemText primary={option.facility_name} />}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ "& input": { height: "0px", padding: "5px 10px" } }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              type="submit"
              sx={{
                boxShadow: "none !important",
                display: "block",
                mt: 3,
                ml: "auto",
              }}
            >
              {loading ? (
                <CircularProgress size={18} sx={{ color: "#fff" }} />
              ) : (
                "Update"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>

      <CustomSnackbar
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Box>
  );
};

export default ProviderBody;
